

/**
 * Created by Ning Jiang on 11/23/2016.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IReelSets} from "@nolimitcity/slot-game/bin/core/reel/reelset/IReelSets";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IGameTweakerConfig} from "@nolimitcity/slot-game/bin/dev/tweaker/GameTweaker";
import {IWinRatios, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {LayerScaleOption, ScaleMethod, ScaleTarget} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import {Back, Ease, Linear} from "gsap";
import {ISpacierArcadeSymbolStates} from "./symbols/SpacierArcadeReelSymbol";
import {ISALayerConfig, SALayerConfig} from "../config/SALayerConfig";
import {SpinMode} from "@nolimitcity/slot-game/bin/core/gametype/SpinMode";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";

export class SpacierArcadeGameConfig implements IGameConfig {

    public static instance: SpacierArcadeGameConfig = new SpacierArcadeGameConfig();
    reelViewExpanded : boolean;

    BROWSER_FPS: number = 30;

    GAME_WIDTH: number = 1280;
    GAME_HEIGHT: number = 720;
    PARTICLE_COUNT:number = 20;
    DEFAULT_LAYER_SCALE_OPTION:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {landscape : LayerScaleOption.REELS_FIT_STAGE},
        mobile : {
            landscape : LayerScaleOption.REELS_FIT_STAGE,
            portrait : LayerScaleOption.REELS_FIT_WINDOW
        }
    };
    LAYERS: ISALayerConfig = SALayerConfig.getConfig();

    BET_WIN_MODE: BetWinMode = BetWinMode.BET_WAY;
    SPIN_MODE:SpinMode = SpinMode.SPIN;

    REEL_AREA_POS_X: number = 0;
    REEL_AREA_POS_Y: number = 90;
    REEL_AREA_WIDTH: number = 720;
    REEL_AREA_HEIGHT: number = 594;
    REEL_AREA_MASK:boolean = true;

    SYMBOL_STATES: ISpacierArcadeSymbolStates = {
        normal: {
            prio: 0,
            keyword: "normal",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        reset: {
            prio: 0,
            keyword: "reset",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        spin: {
            prio: 1,
            keyword: "spin",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        noWin: {
            prio: 2,
            keyword: "noWin",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        toggle: {
            prio: 3,
            keyword: "toggle",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        excitmentPump: {
            prio: 3,
            keyword: "excitmentPump",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        win: {
            prio: 3,
            keyword: "win",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        tinyWin : {
            prio : 3,
            keyword : "tinyWin",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        smallWin : {
            prio : 3,
            keyword : "smallWin",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        individualWin: {
            prio: 4,
            keyword: "individualWin",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        winMulti: {
            prio: 4,
            keyword: "winMulti",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        hidden: {
            prio: 5,
            keyword: "hidden"
        },
        attention : {
            prio : 6,
            keyword : "attention",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        landDead : {
            prio : 6,
            keyword : "landDead",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        sticky : {
            prio : 6,
            keyword : "sticky",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        stickyPump : {
            prio : 6,
            keyword : "stickyPump",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        stickyIntensity : {
            prio : 6,
                keyword : "stickyIntensity",
                texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        fsStickyWild : {
            prio : 6,
            keyword : "fsStickyWild",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        multiplier : {
            prio : 7,
            keyword : "multiplier",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        },
        addFreespin : {
            prio : 7,
            keyword : "addFreespin",
            texturesCreator : (symName:string, stateKey:string) => {
                return [PIXI.Texture.EMPTY];
            }
        }
    };
    SYMBOL_WIDTH: number = 144;
    SYMBOL_HEIGHT: number = 198;
    SYMBOL_HEIGHT_FREESPIN: number = 119;
    SYMBOL_BOTTOM_PADDING: number = 0;

    REELS_NUM: number = 5;
    SPACE_BETWEEN_REELS: number = 0;
    REEL_DISPLAY_POSITIONS: [number, number][] = [
        // [this.REEL_AREA_SIDE_BORDER + this.SYMBOL_WIDTH * 0.5, this.REEL_AREA_HEIGHT - 40],
        // [this.REEL_AREA_SIDE_BORDER + this.SYMBOL_WIDTH * 1.5 + this.SPACE_BETWEEN_REELS, this.REEL_AREA_HEIGHT - 40],
        // [this.REEL_AREA_SIDE_BORDER + this.SYMBOL_WIDTH * 2.5 + this.SPACE_BETWEEN_REELS * 2, this.REEL_AREA_HEIGHT - 40],
        // [this.REEL_AREA_SIDE_BORDER + this.SYMBOL_WIDTH * 3.5 + this.SPACE_BETWEEN_REELS * 3, this.REEL_AREA_HEIGHT - 40],
        // [this.REEL_AREA_SIDE_BORDER + this.SYMBOL_WIDTH * 4.5 + this.SPACE_BETWEEN_REELS * 4, this.REEL_AREA_HEIGHT - 40]];
        [this.SYMBOL_WIDTH * 0.5, (-1 * this.SYMBOL_HEIGHT * 2)],
        [this.SYMBOL_WIDTH * 1.5 + this.SPACE_BETWEEN_REELS, (-1 * this.SYMBOL_HEIGHT * 2)],
        [this.SYMBOL_WIDTH * 2.5 + this.SPACE_BETWEEN_REELS * 2, (-1 * this.SYMBOL_HEIGHT * 2)],
        [this.SYMBOL_WIDTH * 3.5 + this.SPACE_BETWEEN_REELS * 3, (-1 * this.SYMBOL_HEIGHT * 2)],
        [this.SYMBOL_WIDTH * 4.5 + this.SPACE_BETWEEN_REELS * 4, (-1 * this.SYMBOL_HEIGHT * 2)]];
    SYMBOLS_NUM_IN_REEL: [number, number, number, number, number] = [0, 1, 5, 1, 0];


    REEL_SPIN_TIME:number = 0.9;
    REEL_FAST_SPIN_SPIN_TIME:number = 0.2;

    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DELAY:number = 0.3;
    REEL_SPIN_START_EASE:Ease = Linear.easeNone;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY:number = 0;
    REEL_SPIN_STOP_ELASTIC_CONFIG:[number, number] = [0.3, 0.2];
    REEL_SPIN_QUICK_STOP_ELASTIC_CONFIG:[number, number] = [0.3, 0.2];

    REEL_SPIN_START_SPEED:number = 0.12;
    REEL_SPIN_SPIN_SPEED:number = 0.05;
    REEL_NEAR_WIN_SPIN_SPEED:number = 0.03;

    REEL_SPIN_STOP_SPEED:number = 0.5;
    REEL_SPIN_QUICK_STOP_SPEED:number = 0.3;

    REEL_STOP_DELAY:number = 0.3;
    FS_RESPIN_REEL_STOP_DELAY:number = 0.45;
    REEL_QUICK_STOP_DELAY:number = 0.05;
    REEL_NEAR_WIN_STOP_DELAY:number = 2;

    REEL_SETS: IReelSets = {
        "BASE_REELSET" : [
            ["L1", "M1", "L3", "M4", "M1", "L4", "M2", "L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2", "M2", "L1", "L4", "M2", "L1", "M3", "L1", "M2", "M4", "L1", "M2", "M3", "L2", "L1", "L4", "M2", "L1", "M4", "L2", "L4",  "M1", "M4", "M2", "L1", "L4", "L2", "L1", "L4", "M4","L1", "M3", "M2",  "L1", "L4", "M3", "L2", "M2", "M1", "L2", "M2"],
            ["S", "L4", "M3", "M4", "L4", "L3", "M1", "M3", "M4", "L3", "M1", "L4", "M3", "L2", "L4", "M3", "M1", "L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2", "L1", "W", "L3", "M4", "M1", "L2", "M3", "M4", "L3", "M1", "L2", "M4", "L4", "M1", "L3", "L4", "M4", "M3", "L3", "M4", "L4", "L3", "M4",  "M3", "M1", "M4", "L3", "L2", "L4", "L3", "M4", "M3", "L3", "L4", "M1", "M4", "M2", "L2"],
            ["M1", "M2", "L4", "L2", "L2", "L1","L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2",  "L3", "M1", "L4", "L3", "L1", "M4", "M1", "L1", "L3", "M3", "L2", "L1", "L3", "L2", "L3", "M2", "M1", "L4", "L2", "L1", "M4", "L2", "L1", "M2", "M4", "M3", "L2", "M4", "M3", "L1", "S", "L3", "L4", "L1", "L2", "L4", "M1", "L2", "L3", "L4", "M2", "L3", "W", "L2", "M3", "M1", "L2", "M2", "L1"],
            ["W", "L3", "L4", "L1", "M1", "L2", "L4", "L3", "M1", "L1", "L3", "M2", "L1", "L2", "M1", "L3","L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2",  "M2", "L1", "M4", "L3", "S", "M2", "L3", "M4", "M2", "M1", "L4", "M2", "L2", "L4", "L3", "M4", "M1", "L2", "L3", "M4", "M2", "L3", "M1", "L4", "L2",  "M3", "M1", "L2", "L1", "M2", "L4", "M1", "L3", "L4", "L1", "M1", "M3", "L4", "M2", "M3"],
            [ "M4", "L2", "L3", "L1", "L2", "M3", "M4", "L2", "L3", "L1",  "L4", "L3", "M3", "M4", "L1", "L2", "L1", "L2", "M4",  "L1", "M4", "L3",  "M3", "L4", "L1", "L2", "M1", "L3", "L2", "L3", "L1", "M1", "L2", "L4", "L1", "L2", "L4",  "L3", "L1", "M4",  "L3", "L1", "M4", "L4", "L1", "M1", "L4", "M3", "L4", "L2", "M4", "M3", "M1", "L1", "L4"]
        ],
        "FREESPIN_REELSET" : [
            ["L1", "M1", "L3", "M4", "M1", "L4", "M2", "L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2", "M2", "L1", "L4", "M2", "L1", "M3", "L1", "M2", "M4", "L1", "M2", "M3", "L2", "L1", "L4", "M2", "L1", "M4", "L2", "L4",  "M1", "M4", "M2", "L1", "L4", "L2", "L1", "L4", "M4","L1", "M3", "M2",  "L1", "L4", "M3", "L2", "M2", "M1", "L2", "M2"],
            ["S", "L4", "M3", "M4", "L4", "L3", "M1", "M3", "M4", "L3", "M1", "L4", "M3", "L2", "L4", "M3", "M1", "L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2", "L1", "W", "L3", "M4", "M1", "L2", "M3", "M4", "L3", "M1", "L2", "M4", "L4", "M1", "L3", "L4", "M4", "M3", "L3", "M4", "L4", "L3", "M4",  "M3", "M1", "M4", "L3", "L2", "L4", "L3", "M4", "M3", "L3", "L4", "M1", "M4", "M2", "L2"],
            ["M1", "M2", "L4", "L2", "L2", "L1","L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2",  "L3", "M1", "L4", "L3", "L1", "M4", "M1", "L1", "L3", "M3", "L2", "L1", "L3", "L2", "L3", "M2", "M1", "L4", "L2", "L1", "M4", "L2", "L1", "M2", "M4", "M3", "L2", "M4", "M3", "L1", "S", "L3", "L4", "L1", "L2", "L4", "M1", "L2", "L3", "L4", "M2", "L3", "W", "L2", "M3", "M1", "L2", "M2", "L1"],
            ["W", "L3", "L4", "L1", "M1", "L2", "L4", "L3", "M1", "L1", "L3", "M2", "L1", "L2", "M1", "L3","L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2",  "M2", "L1", "M4", "L3", "S", "M2", "L3", "M4", "M2", "M1", "L4", "M2", "L2", "L4", "L3", "M4", "M1", "L2", "L3", "M4", "M2", "L3", "M1", "L4", "L2",  "M3", "M1", "L2", "L1", "M2", "L4", "M1", "L3", "L4", "L1", "M1", "M3", "L4", "M2", "M3"],
            [ "M4", "L2", "L3", "L1", "L2", "M3", "M4", "L2", "L3", "L1",  "L4", "L3", "M3", "M4", "L1", "L2", "L1", "L2", "M4",  "L1", "M4", "L3",  "M3", "L4", "L1", "L2", "M1", "L3", "L2", "L3", "L1", "M1", "L2", "L4", "L1", "L2", "L4",  "L3", "L1", "M4",  "L3", "L1", "M4", "L4", "L1", "M1", "L4", "M3", "L4", "L2", "M4", "M3", "M1", "L1", "L4"]
        ],
        "RESPIN_REELSET" : [
            ["L1", "M1", "L3", "M4", "M1", "L4", "M2", "L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2", "M2", "L1", "L4", "M2", "L1", "M3", "L1", "M2", "M4", "L1", "M2", "M3", "L2", "L1", "L4", "M2", "L1", "M4", "L2", "L4",  "M1", "M4", "M2", "L1", "L4", "L2", "L1", "L4", "M4","L1", "M3", "M2",  "L1", "L4", "M3", "L2", "M2", "M1", "L2", "M2"],
            ["S", "L4", "M3", "M4", "L4", "L3", "M1", "M3", "M4", "L3", "M1", "L4", "M3", "L2", "L4", "M3", "M1", "L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2", "L1", "W", "L3", "M4", "M1", "L2", "M3", "M4", "L3", "M1", "L2", "M4", "L4", "M1", "L3", "L4", "M4", "M3", "L3", "M4", "L4", "L3", "M4",  "M3", "M1", "M4", "L3", "L2", "L4", "L3", "M4", "M3", "L3", "L4", "M1", "M4", "M2", "L2"],
            ["M1", "M2", "L4", "L2", "L2", "L1","L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2",  "L3", "M1", "L4", "L3", "L1", "M4", "M1", "L1", "L3", "M3", "L2", "L1", "L3", "L2", "L3", "M2", "M1", "L4", "L2", "L1", "M4", "L2", "L1", "M2", "M4", "M3", "L2", "M4", "M3", "L1", "S", "L3", "L4", "L1", "L2", "L4", "M1", "L2", "L3", "L4", "M2", "L3", "W", "L2", "M3", "M1", "L2", "M2", "L1"],
            ["W", "L3", "L4", "L1", "M1", "L2", "L4", "L3", "M1", "L1", "L3", "M2", "L1", "L2", "M1", "L3","L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2",  "M2", "L1", "M4", "L3", "S", "M2", "L3", "M4", "M2", "M1", "L4", "M2", "L2", "L4", "L3", "M4", "M1", "L2", "L3", "M4", "M2", "L3", "M1", "L4", "L2",  "M3", "M1", "L2", "L1", "M2", "L4", "M1", "L3", "L4", "L1", "M1", "M3", "L4", "M2", "M3"],
            [ "M4", "L2", "L3", "L1", "L2", "M3", "M4", "L2", "L3", "L1",  "L4", "L3", "M3", "M4", "L1", "L2", "L1", "L2", "M4",  "L1", "M4", "L3",  "M3", "L4", "L1", "L2", "M1", "L3", "L2", "L3", "L1", "M1", "L2", "L4", "L1", "L2", "L4",  "L3", "L1", "M4",  "L3", "L1", "M4", "L4", "L1", "M1", "L4", "M3", "L4", "L2", "M4", "M3", "M1", "L1", "L4"]
        ],
        "FREESPIN_RESPIN_REELSET" : [
            ["L1", "M1", "L3", "M4", "M1", "L4", "M2", "L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2", "M2", "L1", "L4", "M2", "L1", "M3", "L1", "M2", "M4", "L1", "M2", "M3", "L2", "L1", "L4", "M2", "L1", "M4", "L2", "L4",  "M1", "M4", "M2", "L1", "L4", "L2", "L1", "L4", "M4","L1", "M3", "M2",  "L1", "L4", "M3", "L2", "M2", "M1", "L2", "M2"],
            ["S", "L4", "M3", "M4", "L4", "L3", "M1", "M3", "M4", "L3", "M1", "L4", "M3", "L2", "L4", "M3", "M1", "L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2", "L1", "W", "L3", "M4", "M1", "L2", "M3", "M4", "L3", "M1", "L2", "M4", "L4", "M1", "L3", "L4", "M4", "M3", "L3", "M4", "L4", "L3", "M4",  "M3", "M1", "M4", "L3", "L2", "L4", "L3", "M4", "M3", "L3", "L4", "M1", "M4", "M2", "L2"],
            ["M1", "M2", "L4", "L2", "L2", "L1","L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2",  "L3", "M1", "L4", "L3", "L1", "M4", "M1", "L1", "L3", "M3", "L2", "L1", "L3", "L2", "L3", "M2", "M1", "L4", "L2", "L1", "M4", "L2", "L1", "M2", "M4", "M3", "L2", "M4", "M3", "L1", "S", "L3", "L4", "L1", "L2", "L4", "M1", "L2", "L3", "L4", "M2", "L3", "W", "L2", "M3", "M1", "L2", "M2", "L1"],
            ["W", "L3", "L4", "L1", "M1", "L2", "L4", "L3", "M1", "L1", "L3", "M2", "L1", "L2", "M1", "L3","L2", "L4",  "M2", "L2", "L4", "M1", "M2", "L1", "L2",  "M2", "L1", "M4", "L3", "S", "M2", "L3", "M4", "M2", "M1", "L4", "M2", "L2", "L4", "L3", "M4", "M1", "L2", "L3", "M4", "M2", "L3", "M1", "L4", "L2",  "M3", "M1", "L2", "L1", "M2", "L4", "M1", "L3", "L4", "L1", "M1", "M3", "L4", "M2", "M3"],
            [ "M4", "L2", "L3", "L1", "L2", "M3", "M4", "L2", "L3", "L1",  "L4", "L3", "M3", "M4", "L1", "L2", "L1", "L2", "M4",  "L1", "M4", "L3",  "M3", "L4", "L1", "L2", "M1", "L3", "L2", "L3", "L1", "M1", "L2", "L4", "L1", "L2", "L4",  "L3", "L1", "M4",  "L3", "L1", "M4", "L4", "L1", "M1", "L4", "M3", "L4", "L2", "M4", "M3", "M1", "L1", "L4"]
        ],
    };

    WIN_RATIOS: IWinRatios = {
        normalWin: [
            {
                ratio: 0,
                text: "Tiny Win",
                duration: 0,
                type: WinRatioType.TINY
            },
            {
                ratio: 1.5,
                text: "Small Win",
                duration: 0,
                type: WinRatioType.SMALL
            },
            {
                ratio: 3,
                text: "Medium Win",
                duration: 1.109,
                type: WinRatioType.MEDIUM
            },
            {
                ratio: 5,
                text: "Large Win",
                duration: 1.460,
                type: WinRatioType.LARGE
            }
        ],
        bigWin: [
            {
                ratio : 15,
                text : "Big win",
                duration : 5.834,
                type : WinRatioType.BIG_WIN
            },
            {
                ratio : 25,
                text : "Massive win",
                duration : 5.914,
                type : WinRatioType.MEGA_WIN

            },
            {
                ratio : 50,
                text : "Big bang",
                duration : 5.914,
                type : WinRatioType.SUPER_MEGA_WIN
            }
        ]
    };

    NEW_BET_WHEN_ABORT_WIN_PRESENTATIONS: boolean = false;

    // GAME_TWEAKER_CONFIG: IGameTweakerConfig = {
    //     layer: this.LAYERS.TWEAK_MODULE.name,
    //     baseWindowWidth: 400,
    //     moduleHeight: 32,
    //     copyAllButtonText: "Copy All",
    //     buttonSkinIdle: "button",
    //     buttonSkinOver: "button",
    //     buttonSkinDown: "button",
    //     buttonSkinDisabled: "button-disabled"
    // };
    PERFORMANCE_LOGGER: boolean = false;

    STACKED_SYMBOLS: any = [];

    private constructor() {
        if (SpacierArcadeGameConfig.instance) {
            throw new Error("SpacierArcadeGameConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}

